export default (element: HTMLElement) => {
  const expandButton = element.querySelector<HTMLButtonElement>(
    '[data-expand-button]',
  );

  if (!expandButton) {
    console.error('Missing expand buttony in teamCard component');
    return;
  }

  expandButton.addEventListener('click', () => {
    const isCollapsed = element.classList.contains('teamCard--collapsed');

    if (isCollapsed) {
      // Expand
      element.classList.remove('teamCard--collapsed');
      expandButton.setAttribute('aria-label', 'Sbalit');
    } else {
      // Collapse
      element.classList.add('teamCard--collapsed');
      expandButton.setAttribute('aria-label', 'Rozbalit');
    }
  });
};
